import styled from 'styled-components/macro';
import { typography } from 'styled-system';
import Flex from './Flex';

export const Title = styled(Flex)`
  font-family: Abhaya Libre;
  font-size: 24px;
  font-weight: bold;
  justify-content: center;
  color: ${props => props.theme.colors.copy};
  ${typography}
`;
